module.exports = __webpack_public_path__ + "static/media/Manufacturing Processes.efd278e7.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/MECH/Manufacturing Processes.pdf
// module id = 141
// module chunks = 0